var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85623 11.6858L8.85623 11.6858C8.82188 11.769 8.78853 11.8525 8.7562 11.9363C6.96851 12.5341 5.03142 12.534 3.24375 11.9362C3.21144 11.8524 3.17811 11.7689 3.14377 11.6858C3.04854 11.4554 3.00093 11.3401 2.91839 11.2337C2.83585 11.1273 2.69186 11.0193 2.40387 10.8033C0.944332 9.70887 0 7.96472 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.96472 11.0557 9.70887 9.59613 10.8033L9.59612 10.8034C9.30814 11.0193 9.16414 11.1273 9.08161 11.2337C8.99907 11.3401 8.95146 11.4554 8.85623 11.6858ZM3.85021 14.1664C3.93686 14.6932 3.98631 15.227 3.99753 15.7639C4.00056 15.9086 4.08174 16.0409 4.21115 16.1056C5.33726 16.6686 6.66274 16.6686 7.78885 16.1056C7.91826 16.0409 7.99944 15.9086 8.00247 15.7639C8.01369 15.227 8.06314 14.6933 8.14978 14.1665C6.73183 14.4573 5.26815 14.4573 3.85021 14.1664Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.76f3370983471fa629cad686ad6f8ec8.svg";
export { ForwardRef as ReactComponent };